export class Utilities {
  static groupBy(xs: Array<any>, key: any, value: any): Array<any> {
    return xs.reduce(function (rv: Array<any>, x: Array<any>) {
      const v = key instanceof Function ? key(x) : x[key];
      const el = rv.find((r: any) => r && r.key === v);

      if (el) {
        el.values.push(x[value]);
      } else {
        rv.push({ key: v, values: [x[value]] });
      }

      return rv;
    }, []);
  }

  // Use a cryptographically secure random number generator
  static getSecureRandomInt(min: number, max: number): number {
    const cryptoObj = window.crypto || (window as unknown as { msCrypto?: Crypto }).msCrypto;
    if (cryptoObj && typeof cryptoObj.getRandomValues === "function") {
      const range = max - min;
      if (range <= 0) return min;
      const maxUint32 = 0xffffffff;
      let rand: number;
      do {
        const array = new Uint32Array(1);
        cryptoObj.getRandomValues(array);
        rand = array[0] / (maxUint32 + 1);
      } while (rand >= 1);
      return min + Math.floor(rand * range);
    }
  }
}
